var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSaveInput = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#43C78F",
  d: "M6.366 11.717a.7.7 0 0 1-.25-.042.6.6 0 0 1-.216-.142L3.033 8.667a.62.62 0 0 1-.175-.476.67.67 0 0 1 .192-.474.63.63 0 0 1 .466-.184q.285 0 .467.184L6.366 10.1l5.65-5.65a.64.64 0 0 1 .476-.183q.291 0 .474.183.184.183.184.475a.64.64 0 0 1-.184.475l-6.133 6.133a.6.6 0 0 1-.217.142.7.7 0 0 1-.25.042"
})));
export default SvgSaveInput;